const config = {
  siteTitle: "Heartfulness Donations", // Site title.
  siteTitleShort: "HFN Donations", //  Short site title for homescreen (PWA). Preferably should be under 12 characters to prevent truncation.
  siteTitleAlt: "Heartfulness Donations | donations.heartfulness.org", // Alternative site title for SEO.
  siteLogo: "/imgs/heartfulness-new-logo.png", // Logo used for SEO and manifest.
  pathPrefix: "/", // Prefixes all links. For cases when deployed to example.github.io/gatsby-advanced-starter/.
  siteDescription: "Heartfulness Donation", // Website description used for RSS feeds/meta description tag.
  // siteFBAppID: "1825356251115265", // FB Application ID for using app insights
  // googleAnalyticsID: "UA-61002286-7", // GA tracking ID.
  dateFromFormat: "YYYY-MM-DD", // Date format used in the frontmatter.
  dateFormat: "DD/MM/YYYY", // Date format for display.
  copyright: `Copyright © ${new Date().getFullYear()}. Heartfulness. All Rights Reserved`, // Copyright string for the footer of the website and RSS feed.
  themeColor: "#013B28", // Used for setting manifest and progress theme colors.
  backgroundColor: "#fff", // Used for setting manifest background color.
  gtmTrackingId: "GTM-5C7D2RN",
  auth_dot_net_apiLoginId: "42jDW4hdz6",
  auth_dot_net_clientKey:
    "5xSPG54F4D8UFJSR54Wj3ft7wx68B9tU4RmM9zQ8CtJeGj6H5rtdVNP3zpvRd4hv",
};

// Validate

// Make sure pathPrefix is empty if not needed
if (config.pathPrefix === "/") {
  config.pathPrefix = "";
} else {
  // Make sure pathPrefix only contains the first forward slash
  config.pathPrefix = `/${config.pathPrefix.replace(/^\/|\/$/g, "")}`;
}

module.exports = config;
